export class NoValidatorError extends Error {
  constructor(blockKey: string, validatorKey: string) {
    super('No Validator implemented for block ' + blockKey + ' and validator ' + validatorKey);
  }
}
